export const textItemDragStyle = `position: absolute; top: -1000px; font-size: 14px; padding: 4px 8px; background: white; border-radius: 4px;`;
